<script>
import {
  custos,
  emitirDocumentoRetirada,
  emitirDocumentoRetiradaLeilao,
  emitirGuiaPagamento,
  excluirLote
} from '../../../../domain/grv/services'
import createDownloadLink from '../../../../utils/create-download-link'
import {isRetiradoPorLeilao, StatusTitle} from '../../../../domain/grv/helpers/GrvStatus'
import {
  Status as StatusPreRetirada,
  StatusTitle as StatusTitlePreRetirada
} from '../../../../domain/grv/helpers/PreRetiradaStatus'
import RetiradaService from '../../../../domain/retirada/services'
import {deletePreRetirada} from '../../../../domain/pre-retirada/services'
import {isArray} from 'lodash'
import AclCheckMixins from '../../../_default/components/mixins/AclCheckMixins'

export default {
  name: 'GrvPatioMixins',
  mixins: [AclCheckMixins],
  computed: {
    StatusPreRetirada () {
      return StatusPreRetirada
    },
    isRetiradoPorLeilao () {
      return isRetiradoPorLeilao(this.data.status)
    },
    hasPendencias () {
      return (!this.data.preretiradas) || (this.data.preretiradas && this.calculo.base.valorPago === 0) || (this.data.preretiradas && this.calculo.base.saldoDevedor > 0) || (this.data.preretiradas && this.calculo.base.saldoDevedor < 0)
    }
  },
  methods: {
    emitirGuiaPagamento (preretirada) {
      this.$bar.start()
      this.$loaderOverlay.open().message('Gerando documento, aguarde...')
      emitirGuiaPagamento(preretirada.id)
        .then((response) => {
          let callbackEnd = () => {
            createDownloadLink(response.data, `guia_pagamento_grv_${this.data.numero}.pdf`, false)
            this.$bar.finish()
            this.$loaderOverlay.hide()
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
    },
    emitirDocumentoRetirada () {
      this.$bar.start()
      this.$loaderOverlay.open().message('Gerando documento, aguarde...')
      const fn = this.isRetiradoPorLeilao ? emitirDocumentoRetiradaLeilao : emitirDocumentoRetirada
      fn(this.$route.params.id)
        .then((response) => {
          let callbackEnd = () => {
            createDownloadLink(response.data, `retirada_grv_${this.data.numero}.pdf`, false)
            this.$bar.finish()
            this.$loaderOverlay.hide()
          }
          callbackEnd()
        }).catch((response) => {
          this.$bar.finish()
          this.$loaderOverlay.hide()
          this.cadastroError = response.data.errors
          this.$nextTick(() => {
            this.$refs.error.focus()
          })
          console.log(response)
        })
    },
    calculoCustos () {
      custos(this.$route.params.id)
        .then((response) => {
          this.calculo = response.data
          this.isFullyLoaded = true
          console.log(response)
          this.$loaderOverlay.hide()
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    StatusTitle (s, t) {
      return StatusTitle(s, t)
    },
    StatusTitlePreRetirada (s, t) {
      return StatusTitlePreRetirada(s, t)
    },
    consultaPagamento (preretirada) {
      this.preretiradaConsulta = preretirada
      this.showConsultaPagamento = true
    },
    closeConsultaPagamento () {
      this.showConsultaPagamento = false
    },
    excluirLote () {
      const confirmado = confirm('O lote relacionado a essa grv será retirado do leilão mais recente, Confirmar?')
      if (!confirmado) return

      this.$loaderOverlay.open().message('Retirando lote...')
      excluirLote(this.$route.params.id)
        .then(response => {
          this.start()
        })
        .catch(error => {
          alert('Houve um erro ao executar a operação')
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    },
    retirada () {
      this.$router.push({name: 'retirada.adicionar', params: {id: this.data.id}})
    },
    excluirRetirada () {
      const confirmado = confirm('Confirmar exclusão de retirada? Essa operação NÃO pode ser desfeita.')
      if (!confirmado) return

      this.$loaderOverlay.open().message('Excluindo retirada...')
      RetiradaService.delete(this.data.retirada.id)
        .then(response => {
          this.start()
          alert('Retirada excluída. Agora vc pode alterar o status da GRV para o correto.')
        })
        .catch(error => {
          alert(this.printError(error.data.errors))
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    },
    excluirPreRetirada (id) {
      const confirmado = confirm('Confirmar exclusão de pré-retirada? Essa operação NÃO pode ser desfeita.')
      if (!confirmado) return

      this.$loaderOverlay.open().message('Excluindo...')
      deletePreRetirada(id)
        .then(response => {
          this.start()
          alert('Pré-retirada excluída.')
        })
        .catch(error => {
          alert(this.printError(error.data.errors))
          console.log(error.data)
          this.$loaderOverlay.hide()
        })
    },
    printError (err) {
      if (isArray(err)) {
        return err[0]
      }
      return err
    }
  }
}
</script>

<template>

</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// GrvPatioMixins.vue?2b2c9631